import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export const StyledSpinner = styled.svg({
/*  animation: 'spin 2s linear infinite',
'@keyframes spin': {
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
},*/
});
const Spinner = (props) => {
    const size = 100;
    const stroke = size / 10;
    const radius = (size - stroke) / 2;
    const circumference = radius * Math.PI * 2;
    const dash = circumference * 0.75;
    return (_jsx("span", { ...props, children: _jsxs(StyledSpinner, { width: '100%', height: '100%', viewBox: `0 0 ${size} ${size}`, children: [_jsx("circle", { fill: 'none', stroke: 'currentColor', strokeOpacity: '0.2', cx: size / 2, cy: size / 2, r: radius, strokeWidth: `${stroke}px` }), _jsx("circle", { fill: 'none', stroke: 'currentColor', cx: size / 2, cy: size / 2, r: radius, strokeWidth: `${stroke}px`, transform: `rotate(-90 ${size / 2} ${size / 2})`, strokeDasharray: [dash, circumference - dash].join(','), strokeLinecap: 'round' })] }) }));
};
Spinner.displayName = 'Spinner';
export default Spinner;
